import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetUWellnessProgramDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_UWellnessProgram_DETAILS, token);
  return res;
};

export const GetUWellnessProgramById = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_UWellnessProgram_DETAILS_BY_ID + id,
    token
  );
  return res;
};

export const AddWellness = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_UWellnessProgram, payload, token);
  return res;
};

export const DeleteUWellnessProgram = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_UWellnessProgram + id, id, token);
  return res;
};
